import { render, staticRenderFns } from "./SBRadio.html?vue&type=template&id=5b21d664&scoped=true&"
import script from "./SBRadio.ts?vue&type=script&lang=ts&"
export * from "./SBRadio.ts?vue&type=script&lang=ts&"
import style0 from "./SBRadio.css?vue&type=style&index=0&id=5b21d664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b21d664",
  null
  
)

export default component.exports